// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1rOqh","buttons":"SendReceipts_buttons__3Ae6C","email":"SendReceipts_email__2I_bb","bookApptTitle":"SendReceipts_bookApptTitle__2PyWh"};